import apiClient from '@/services/axios'

export async function post({ lessonId, courseId }) {
  var response = await apiClient.post(`/CourseInstances/${courseId}/retakeFailed/${lessonId}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to start after fail.')
}
